import React from "react";
export default function RqthBadge({value}) {
 if(value!==true && value!=="true" && value!==1)return null;
 return <span title="Reconnaissance de la qualité de travailleur handicapé" className="ml-2 inline-flex shrink-0 items-center rounded-md border border-red-200 bg-red-50 px-2 py-0.5 text-xs font-semibold text-red-700">RQTH</span>;
}
